// styles
import styles from '../detail.module.scss';

// utils
import { classNameBuilder } from 'utils/classNameBuilder';

type AccWrapperProps = {
  isAcc: boolean;
  isNord: boolean;
  openAcc: boolean;
};

export function AccWrapper({
  isAcc,
  isNord,
  openAcc,
  children,
}: Readonly<React.PropsWithChildren<AccWrapperProps>>) {
  if (isAcc) {
    return (
      <div
        className={classNameBuilder(openAcc ? styles.open : styles.closed, isNord && styles.nord)}
      >
        <div className={classNameBuilder(styles.sidebarAccWrapper, isNord && styles.nord)}>
          {children}
        </div>
      </div>
    );
  }

  return children;
}
